"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapObject = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const omit_1 = __importDefault(require("lodash/omit"));
const ObjectWithHistory_1 = require("./ObjectWithHistory");
/**
 * An object that can be rendered as a feature on map
 */
class MapObject extends ObjectWithHistory_1.ObjectWithHistory {
    constructor(attributes = {}, isNew = true, collectionManager) {
        super(attributes, isNew);
        this.hasChangedGeography = () => {
            return (this.isNew() && this._attributes.geography !== undefined) || this.hasChanged('geography');
        };
        this._collectionManager = collectionManager;
    }
    get collectionManager() {
        return this._collectionManager;
    }
    toGeojson() {
        return {
            id: this.attributes.integer_id || 1,
            geometry: this.attributes.geography,
            type: 'Feature',
            properties: (0, omit_1.default)(this.attributes, 'data')
        };
    }
}
exports.MapObject = MapObject;
exports.default = MapObject;
//# sourceMappingURL=MapObject.js.map